export default "__VITE_PUBLIC_ASSET__e699f4db__"